import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export const unitsApiKeyStore = {
  getUnits: (): QueryKeyConfig => ({
    queryKey: [`GET_UNITS`],
    route: `/unit`,
  }),
  getUnitDetails: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_DETAILS`, unitID],
    route: `/unit/${unitID}`,
  }),
  getCustomerUnits: (customerID: number): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_UNITS`, customerID],
    route: `/unit?customerID=${customerID}`,
  }),
  getOfficeUnits: (officeID: number): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_UNITS`, officeID],
    route: `/unit?OfficeID=${officeID}`,
  }),
  getProjectUnits: (projectID: number): QueryKeyConfig => ({
    queryKey: [`GET_PROJECT_UNITS`, projectID],
    route: `/unit?ProjectID=${projectID}`,
    isEnabled: !!projectID && projectID !== undefined && projectID !== null,
  }),
  updateUnit: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_UNIT`],
    route: `/unit`,
    action: 'PUT',
  }),
  unitComplete: (): MutationKeyConfig => ({
    mutationKey: [` UNIT_COMPLETE`],
    route: `/Unit/Complete `,
    action: 'PUT',
  }),
  updateMunicipality: (unitID: any, municipalityID?: any): MutationKeyConfig => ({
    mutationKey: [`UPDATE_MUNICIPALITY`],
    route: `/unit/MunicipalityMapping?unitid=${unitID}&municipalityid=${municipalityID}`,
    action: 'PUT',
  }),
  deleteUnitService: (unitID: number, serviceID: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_UNIT_SERVICE`, unitID, serviceID],
    route: `/Unit/unitid/${unitID}/serviceid/${serviceID}`,
    action: 'DELETE',
  }),
  getSearchUnits: (searchText: any): QueryKeyConfig => ({
    queryKey: [`GET_SEARCH_UNITS`, searchText],
    route: `/unit?SearchText=${searchText}`,
    isEnabled: !!searchText,
  }),
  getSearchJobsites: (searchText: any): QueryKeyConfig => ({
    queryKey: [`GET_SEARCH_JOBESITES`, searchText],
    route: `/unit?Jobsite=${searchText}`,
    isEnabled: !!searchText,
  }),
  updateUnitInfo: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_UNIT_INFO`],
    route: `/Unit/UnitInfo`,
    action: 'PUT',
  }),
  deleteUnitFile: (unitID: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_UNIT_FILE`, unitID],
    route: `/Unit/${unitID}/HVACDesignFile`,
    action: 'DELETE',
  }),
  getUnitProfileDetails: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_PROFILE_DETAILS`, unitID],
    route: `/Unit/ProfileStatistics/${unitID}`,
  }),
  getUnitProfileKeyDetails: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_KEY_DETAILS`, unitID],
    route: `/Unit/KeyDetails/${unitID}`,
  }),
  getUnitPermitType: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_PERMIT_TYPE`, unitID],
    route: `/unit/${unitID}/PermitTypes`,
  }),

  getCustomerUnitsWithStatus: (customerID: number, status: string): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_UNITS_WITH_STATUS`, customerID, status],
    route: `/unit?customerID=${customerID}&Status=${status}`,
  }),
  getOfficeUnitsWithStatus: (officeID: number, status: string): QueryKeyConfig => ({
    queryKey: [`GET_OFFICE_UNITS_WITH_STATUS`, officeID, status],
    route: `/unit?OfficeID=${officeID}&Status=${status}`,
  }),
  getProjectUnitsWithStatus: (projectID: number, status: string): QueryKeyConfig => ({
    queryKey: [`GET_PROJECT_UNITS_WITH_STATUS`, projectID, status],
    route: `/unit?ProjectID=${projectID}&Status=${status}`,
    isEnabled: !!projectID && projectID !== undefined && projectID !== null,
  }),

  getUnitsWithStatus: (status: string): QueryKeyConfig => ({
    queryKey: [`GET_UNITS_WITH_STATUS`, status],
    route: `/unit?Status=${status}`,
  }),

  generateDoxCoc: (unitId: any): MutationKeyConfig => ({
    mutationKey: [`GENERATE_DOX_COC`, unitId],
    route: `/Unit/DuxCocGenerate/${unitId}`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getUnitInspectionReports: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_INSPECTION_REPORTS`, unitID],
    route: `/Unit/${unitID}/WorkOrderInspectionReportsForBulkDownload`,
    isEnabled: !!unitID
  }),
  downloadInspectionReports: (): MutationKeyConfig => ({
    mutationKey: [`DOWNLOAD_ISNPECTION_REPORTS`],
    route: `/Unit/WorkOrderBulkInspectionReportDownload`,
    action: 'POST',
  }),
  getFileTypes: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_FILE_TYPES`, unitID],
    route: `/Unit/${unitID}/FileTypes`,
    isEnabled: !!unitID
  }),
  deleteUnitAccReportFile: (unitID: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_UNIT_FILE`, unitID],
    route: `/Unit/${unitID}/ACCAReportFileDelte`,
    action: 'DELETE',
  }),
  getEmailContactsForUnit: (unitID: any): QueryKeyConfig => ({
    queryKey: [`GET_EMAIL_CONTACTS_FOR_UNIT`, unitID],
    route: `/Unit/GetUnitContactsForCOCmail?unitid=${unitID}`,
    isEnabled: !!unitID
  }),
   getProjectsUnits: (projectIDs: number[]): QueryKeyConfig => ({
    queryKey: [`GET_PROJECTS_UNITS`, ...(projectIDs ? projectIDs : [])],
    route: `/Unit/GetUnitsForMultipleProjects?${projectIDs?.map((o) => `ProjectIDs=${o}`)?.join('&')}`,
    isEnabled: projectIDs !== undefined && projectIDs !== null,
  }),
};
